module.exports = __webpack_public_path__ + "static/media/barnes-and-noble.3293483e.png";